import { createSlice } from "@reduxjs/toolkit";
import { getDominDetail } from "./ThunkAction";
import { iMetaDataState, REDUCER_NAME } from "./Types";

const initialState: iMetaDataState = {
  isLoading: false,
  getDomainList: null, // single domain detail object
  errorMessage: null,
};

export const domainDetailSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetMetaDataState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // 🔄 Pending
      .addCase(getDominDetail.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })

      // ✅ Fulfilled
      .addCase(getDominDetail.fulfilled, (state, action) => {
        const payload = action.payload;

        if (payload?.data?.data) {
          // API returns single domain detail object
          state.getDomainList = payload.data.data;
        }

        state.isLoading = false;
      })

      // ❌ Rejected
      .addCase(getDominDetail.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage =action.payload?.message ?? "Failed to fetch domain details";
        state.isLoading = false;
      });
  },
});

export const { resetMetaDataState } = domainDetailSlice.actions;
export default domainDetailSlice.reducer;
